<template>
    <div v-if="canPurchaseRenewal()">
        <div class="main-title"><h2>{{ getTranslation('front', 'subscription_renewal_box_title') }}</h2></div>
        <div class="row justify-content-center mb-4">
            <div class="col-md-12">
                <div class="licenses__wrapper details-panel details-panel__white py-0 mt-0">
                    <div class="order-summary__body mb-5">
                        <template v-if="showProlongButton()">
                            <div class="row d-flex align-items-center">
                                <div class="col-md-8 col-12 d-flex align-items-center my-3" >
                                    <div class="align-middle">


                                        <template
                                            v-for="uniqueDate in uniqueLeaseDates"
                                        >
                                            <div
                                                class="renewalText"
                                                v-html="getTranslation ('lease-prolong-vue', 'product_subscription_renewal_for_date', {product: uniqueDate.productName, date: formatDateByLang(uniqueDate.date) } )"
                                            ></div>

                                        </template>
                                    </div>
                                </div>
                                <div class="col-md-4 col-12 col-12 d-flex  my-3">
                                    <a onclick="window.productList.goToKeySetup();" class="btn btn-order">{{ getTranslation ('lease-prolong-vue', 'renew_now') }}</a>
                                </div>
                            </div>
                        </template>
                        <template v-for="product in products" v-if="leaseProlongPrice[product.id]">
                            <div class="lease-prolong-row" v-if="leaseProlongPrice[product.id]">
                                <template v-if="isTruss4Product(product.id)">
                                    <lease-prolong v-bind:product="product.id"></lease-prolong>
                                </template>
                            </div>

                        </template>
                    </div>
                </div>
            </div>
        </div>

    </div>

</template>


<script>
    export default {
        methods: {
            canPurchaseRenewal() {
                return this.checkCanPurchaseLeaseProlong;
            },
            addToCart(product) {
                this.$store.commit('toggleLeaseProlong', product.id);
            },
            showProlongButton() {
                let show = false;
                let self = this;
                _.forOwn(this.products, function(product) {
                    if (!self.isTruss4Product(product.id) && !_.isNil(self.$store.state.cart.leaseProlong[product.id])) {
                        show = true;
                    }
                });
                return show;
            },
            getUniqueDates() {
                let self = this;
                let dates = [];
                _.forOwn(this.products, function(product) {
                    if (!self.isTruss4Product(product.id) && !_.isNil(self.$store.state.cart.leaseProlong[product.id])) {
                        let info = self.$store.state.cart.leaseProlong[product.id].info;
                        let uniqueDates = _.uniq(_.map(info, 'version'));
                        _.forEach(uniqueDates, function(date) {
                            dates.push({
                                date: date,
                                product: product.id,
                                productName: product.name,
                            });
                        })
                    }
                });

                return dates;
            }
        },
        computed: {
            status: {
                get () {
                    let self = this;
                    let status = {};
                    _.forOwn(this.products, function(product, productId) {
                        status[product.id] = false;
                        if (!_.isNil(self.$store.state.cart.leaseProlong[product.id])) {
                            status[product.id] = self.$store.state.cart.leaseProlong[product.id].status || false;
                        }
                    });
                    return status;
                },
                set (val) {
                    //
                }
            },
            checkCanPurchaseLeaseProlong() {
                let canPurchase = false;
                let self = this;
                _.forOwn(this.products, function(product, productId) {
                    if (!_.isNil(self.leaseProlong[productId]) ) {
                        canPurchase = true;
                    }
                });

                return canPurchase;
            },
            leaseProlongPrice() {
                let self = this;
                let totalPrice = {};
                _.forOwn(this.products, function(product, productId) {
                    totalPrice[productId] = 0;
                    if (_.isNil(self.$store.state.cart.leaseProlong[productId])) {
                        totalPrice[productId] = 0;
                    } else if (_.isNil(self.$store.state.cart.leaseProlong[productId].info)) {
                        totalPrice[productId] = 0;
                    } else {
                        _.forOwn(self.$store.state.cart.leaseProlong[productId].info, function(pr, key) {
                            totalPrice[productId] += self.getProgramPrice(pr.id, '', 'cloud_time_quantity', productId, pr.quantity)
                        });
                    }
                });
                return totalPrice;
            },
        },
        data() {
            return {
                products: window.jsonProducts,
                navigation: window.quickNavigationUrls,
                leaseProlong: JSON.parse(window.leaseProlong),
                uniqueLeaseDates: []
            };
        },
        beforeMount() {
            this.uniqueLeaseDates = this.getUniqueDates();
        }
    }
</script>

<style>
.renewalText {
    font-size: 18px;
    font-weight: bold;
}
</style>
